import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import { MdEdit, MdDelete, MdPrint } from 'react-icons/md';

export const Container = styled.div``;

export const ContainerSearch = styled.div`
  display: flex;
  justify-content: center;
  /* width: 100%; */
  min-width: 500px;
  padding: 0 16px;

  & > div {
    max-width: 400px;
    transition: max-width 0.2s;
  }
  & > div:hover {
    max-width: 500px;
  }
`;

export const Panel = styled.div`
  background: var(--background-panel);
  top: -50px;
  border-radius: 8px;
  position: relative;
  margin: 0px 32px 0px 32px;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 2px;

  .tbl-content {
    max-height: 500px;
    overflow-x: auto;
    margin-top: 0px;
    /* border: 1px solid rgba(255, 255, 255, 0.3); */
    border-radius: 8px;
  }
`;

export const PaginationContainer = styled.div`
  height: 52px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  background: var(--background);
  padding: 0px 16px;
  /* border-top: 1px solid #e0e0e0fc; */
`;

const IconCss = css`
  flex-shrink: 0;
  padding: 4px;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  margin-right: 12px;
  cursor: pointer;

  &:hover {
    background: #ffffff12;
  }
`;

const IconHeaderCss = css`
  flex-shrink: 0;
  padding: 4px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 12px;
  cursor: pointer;
  color: #fff;

  &:hover {
    background: #ffffff12;
  }
`;

export const IconEdit = styled(MdEdit)`
  ${IconCss}
`;

export const IconDelete = styled(MdDelete)`
  ${IconCss}
`;

export const IconPrintVenda = styled(MdPrint)`
  ${IconCss}
`;

export const IconPrint = styled(MdPrint)`
  ${IconHeaderCss}
`;

export const ButtonPrint = styled(Link)``;

export const FooterModal = styled.div`
  display: flex;
  justify-content: flex-end;
  background-color: yellow;
`;

export const HeaderButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
